import React, { useEffect, useState } from 'react'
import Layout from '../common/Layout'
import ApiHelper from '../../helperFunction/ApiHelper'
import API_ENDPOINTS from '../../helperFunction/Constant'
import { Link } from 'react-router-dom'

const Dashboard = () => {

  const userType = localStorage.getItem('userType')

  const [ordersData, setOrdersData] = useState([])

    useEffect(() => {
        if (userType === 'affiliate') getOrders()
    }, [])

    const getOrders = () => {
      ApiHelper.get(`${API_ENDPOINTS.AFFILIATE_USER_ORDERS}/affiliate-dashboard`).then((res) => {
        console.log('res: ',res);
        if (res.status === 200) {
          setOrdersData(res.data.data[0])
        }
      }).catch((error) => {
        console.log("Error: ", error);
      })
    }

  return (
    <>
      <Layout>
      {userType === 'affiliate' && (
          <div class="content-wrapper">
            <div class="container-xxl flex-grow-1 container-p-y">
                <div class="d-flex justify-content-between align-items-center py-3">
                <h4 class="fw-bold py-3 mb-2"><span class="text-muted fw-light"><p className="breadcrumb-item active mb-0" aria-current="page">Dashboard</p></span></h4>
                </div>
                <div className="row">
                    <div className="col-md-4 mb-3">
                        <label className="fw-semibold text-muted">Affiliate Code</label>
                        <p className="mb-0">{ordersData?.affiliateCode || "-"}</p>
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="fw-semibold text-muted">Full Name</label>
                        <p className="mb-0">{ordersData?.fullName || "-"}</p>
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="fw-semibold text-muted">Email</label>
                        <p className="mb-0">{ordersData?.email || "-"}</p>
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="fw-semibold text-muted">Mobile Number</label>
                        <p className="mb-0">{ordersData?.mobileNumber || "-"}</p>
                    </div>
                    {ordersData?.companyName && (
                        <div className="col-md-4 mb-3">
                            <label className="fw-semibold text-muted">Company Name</label>
                            <p className="mb-0">{ordersData?.companyName || "-"}</p>
                        </div>
                    )}
                    {ordersData?.websiteOrSocialProfile && (
                        <div className="col-md-4 mb-3">
                            <label className="fw-semibold text-muted">Website / Social Profile</label>
                            <br/>
                            <Link to={ordersData?.websiteOrSocialProfile} target="_blank" rel="noreferrer" >
                                {ordersData?.websiteOrSocialProfile || "-"}
                            </Link>
                        </div>
                    )}
                    <div className="col-md-4 mb-3">
                        <label className="fw-semibold text-muted">PAN Number</label>
                        <p className="mb-0">{ordersData?.panNumber || "-"}</p>
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="fw-semibold text-muted">GST Number</label>
                        <p className="mb-0">{ordersData?.gstNumber || "-"}</p>
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="fw-semibold text-muted">Commission</label>
                        <p className="mb-0">{ordersData?.commissionPercentage}%</p>
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="fw-semibold text-muted">Payment Method</label>
                        <p className="mb-0">{ordersData?.paymentMethod}</p>
                    </div>
                    {ordersData?.paymentMethod === "upi" && (
                        <div className="col-md-4 mb-3">
                            <label className="fw-semibold text-muted">UPI ID</label>
                            <p className="mb-0">{ordersData?.upiId}</p>
                        </div>
                    )}
                    {ordersData?.paymentMethod === "bank" && (
                      <>
                        <div className="col-md-4 mb-3">
                            <label className="fw-semibold text-muted">Account Holder</label>
                            <p className="mb-0">{ordersData?.accountHolderName}</p>
                        </div>
                        <div className="col-md-4 mb-3">
                            <label className="fw-semibold text-muted">Bank Name</label>
                            <p className="mb-0">{ordersData?.bankName}</p>
                        </div>
                        <div className="col-md-4 mb-3">
                            <label className="fw-semibold text-muted">Account Number</label>
                            <p className="mb-0">{ordersData?.accountNumber}</p>
                        </div>
                        <div className="col-md-4 mb-3">
                            <label className="fw-semibold text-muted">IFSC Code</label>
                            <p className="mb-0">{ordersData?.ifscCode}</p>
                        </div>
                        <div className="col-md-4 mb-3">
                            <label className="fw-semibold text-muted">Cancelled Cheque</label>
                            <br/>
                            {ordersData?.cancelledCheque ? (
                                <div>
                                    <Link to={`${process.env.REACT_APP_BASE_URL}/${ordersData?.cancelledCheque}`} target="_blank" rel="noreferrer" className="btn btn-sm btn-outline-primary" > View Document </Link>
                                </div>
                            ) : ('-')}
                        </div>
                      </>
                    )}
                </div>
                <hr/>
                <div class="row g-4 mb-4">
                  <div className='col-md-4'>
                    <div style={{ width: "300px", background: "#fff", borderRadius: "24px", padding: "22px", display: "flex", alignItems: "center", gap: "20px", position: "relative", boxShadow: "0 8px 24px rgba(0,0,0,0.06)", overflow: "hidden", }} >
                      <div>
                        <div style={{ fontSize: "15px", fontWeight: 700, color: "#5D6D87", letterSpacing: "1px", textTransform: "uppercase", marginBottom: "6px", }}>
                          Total Completed Orders
                        </div>
                        <div style={{ fontSize: "40px", fontWeight: 800, color: "#1A1A3D", lineHeight: 1, }}>
                          {ordersData?.affiliateOrderCount}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div style={{ width: "300px", background: "#fff", borderRadius: "24px", padding: "22px", display: "flex", alignItems: "center", gap: "20px", position: "relative", boxShadow: "0 8px 24px rgba(0,0,0,0.06)", overflow: "hidden", }} >
                      <div>
                        <div style={{ fontSize: "15px", fontWeight: 700, color: "#5D6D87", letterSpacing: "1px", textTransform: "uppercase", marginBottom: "6px", }}>
                          Total Commission
                        </div>
                        <div style={{ fontSize: "40px", fontWeight: 800, color: "#1A1A3D", lineHeight: 1, }}>
                          ₹{ordersData?.commissionAmount}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-3'>
                    <div style={{ width: "300px", background: "#fff", borderRadius: "24px", padding: "22px", display: "flex", alignItems: "center", gap: "20px", position: "relative", boxShadow: "0 8px 24px rgba(0,0,0,0.06)", overflow: "hidden", }} >
                      <div>
                        <div style={{ fontSize: "15px", fontWeight: 700, color: "#5D6D87", letterSpacing: "1px", textTransform: "uppercase", marginBottom: "6px", }}>
                          Total Sales
                        </div>
                        <div style={{ fontSize: "40px", fontWeight: 800, color: "#1A1A3D", lineHeight: 1, }}>
                          ₹{ordersData?.totalAffiliateSales}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        )}
      </Layout>
    </>
  )
}

export default Dashboard
